import { api } from "./client";

export type SaleItem = {
  productId: number;
  quantity: number;
};

export type SaleCreate = {
  buyerPhone: string;
  shippingAddress: string;
  totalTransferred: number;
  shippingCostPaid: number;
  items: SaleItem[];
};

export type Sale = {
  id: number;
  buyerPhone: string;
  shippingAddress: string;
  totalTransferred: number;
  shippingCostPaid: number;
  netRevenue: number | null;
  status: string;
  createdAt: string;
};

export const salesApi = {
  getAll: () => api.get<Sale[]>("/api/sales"),
  create: (data: SaleCreate) => api.post<Sale>("/api/sales", data),
};
